import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Button, Divider, Input, Icon, Segment, Menu } from "semantic-ui-react";
import ReactTable from "react-table";

import request from "../../utils/request";

export const columns = [
  {
    accessor: d => (
      d.resource_id === null &&
      <Button as={Link} to={`/social/posts/${d.id}/edit`} icon="edit" primary />
    ),
    id: "id",
    Header: "Action"
  },
  {
    accessor: d => <div><Icon name={d.token.resource_type} /> {d.token.name}</div>,
    id: "token_id",
    Header: "Posted to"
  },
  {
    accessor: "post_at",
    Header: "Posted On"
  },
  {
    accessor: "title",
    Header: "Title"
  },
  {
    accessor: "content",
    Header: "Message"
  }
];

class SocialPostsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMounted: false,
      isLoading: true,
      sort: [{ id: "id", desc: false }],
      data: [],
      query: "",
      limit: 20,
      page: 1,
      total: 0
    };
  }
  componentDidMount = () => {
    this.setState({ isMounted: true });
  };
  fetchData = e => {
    this.setState({ isLoading: true });
    request
      .get(this, "api:/social/post", {
        sort: this.state.sort,
        q: this.state.query,
        page: this.state.page,
        limit: this.state.limit
      })
      .then(resp => {
        this.setState({
          isLoading: false,
          data: resp.data,
          total: Math.ceil(resp.total / this.state.limit)
        });
      });
  };
  handleChange = (e, { name, value }) => {
    this.setState({ query: value });
  };
  handleKeyPress = e => {
    if (e.key === "Enter") {
      this.fetchData();
    }
  };
  handleSearch = e => {
    this.setState({ page: 1 });
    setTimeout(this.fetchData, 200);
  };
  handlePaginationChange = (e, { activePage }) => {
    this.setState({ page: activePage });
    setTimeout(this.fetchData, 200);
  };
  handleSort = (newSorted, column, shiftKey) => {
    this.setState({ sort: newSorted });
  };

  render() {
    const {
      data,
      limit,
      total,
      isLoading
    } = this.state;
    return (
      <Segment basic loading={isLoading}>
        <Menu secondary stackable>
          <Menu.Item>
            <Input
              icon="search"
              iconPosition="left"
              action={() => <Button content="Search" onClick={this.handleSearch} />}
              placeholder="Search..."
              onChange={this.handleChange}
              onKeyPress={this.handleKeyPress}
            />
          </Menu.Item>
          <Menu.Menu position='right'>
            <Menu.Item>
              <Button
                as={Link}
                to={"/social/posts/create"}
                icon="line graph"
                content="New Post"
                primary
                fluid
              />
            </Menu.Item>
          </Menu.Menu>
        </Menu>
        <Divider hidden />
        <ReactTable
          data={data}
          columns={columns}
          className="-striped -highlight"
          manual
          pages={total} // Display the total number of pages
          loading={isLoading} // Display the loading overlay when we need it
          onFetchData={this.fetchData} // Request new data when things change
          resizable={false}
          filterable={false}
          defaultPageSize={limit}
          minRows={0}
          onSortedChange={this.handleSort}
        />
      </Segment>
    );
  }
}

export default SocialPostsList;
